/**
 * リスト画面から詳細画面へ遷移した際に「戻る」ボタンを表示し、
 * 戻った際にスクロール位置を復元するための汎用ミックスイン生成関数
 *
 * @param {string} returnPath - 戻り先のパス (例: '/notifications', '/members')
 * @param {string[]} clearMutations - 戻り先以外へ遷移した際に実行する store の mutation 名の配列
 * @param {string} showButtonKey - ボタン表示フラグの computed キー名
 * @param {Function} visibilityGetter - ボタン表示条件を返す関数 (state) => boolean
 * @param {string} goBackMethodName - 戻るメソッド名
 */
export default function createReturnMixin({ returnPath, clearMutations, showButtonKey, visibilityGetter, goBackMethodName }) {
  return {
    computed: {
      [showButtonKey]() {
        return visibilityGetter(this.$store.state)
      },
    },
    beforeRouteLeave(to, from, next) {
      if (to.path !== `${returnPath}/` && to.path !== returnPath) {
        clearMutations.forEach((mutation) => this.$store.commit(mutation))
      }
      next()
    },
    methods: {
      [goBackMethodName]() {
        this.$router.push(`${returnPath}/`)
      },
    },
  }
}
